// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/rt-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #f2f0eb;
    color: white;
}

.Main_label__APk67 {
    /* width: 188px;
    height: 143px; */
    float: left;
    /* background-size: 200px 148px; */
    cursor: pointer;
    padding-left: 2%;
    padding-right: 1%;
    padding-top: 1%;
    padding-bottom: 1%;
    gap: 5px;
}

.Main_labelArea__-OBHt {
    margin: auto;
    width: 756px;
    display: block;
    overflow: auto;
    height: 100%;
    background-color: white;
    box-shadow: 0px 0px 36px 8px #000000;
    justify-content: space-evenly;
}

.Main_price__0KAuv {
    font-weight: bold;
    font-size: small;
    color: black;
    width: 90%;
    margin: auto;
    text-shadow: rgb(255, 255, 255) 1px 0px 0px,
        rgb(255, 255, 255) 0.540302px 0.841471px 0px,
        rgb(255, 255, 255) -0.416147px 0.909297px 0px,
        rgb(255, 255, 255) -0.989992px 0.14112px 0px,
        rgb(255, 255, 255) -0.653644px -0.756802px 0px,
        rgb(255, 255, 255) 0.283662px -0.958924px 0px,
        rgb(255, 255, 255) 0.96017px -0.279415px 0px;
    background-color: white;
    border-radius: 0 0 15px 15px;
    border-bottom: 2px solid red;
    border-top: 1px solid red;
    border-left: 2px solid red;
    border-right: 2px solid red;
}

.Main_name__CGgcW {
    font-weight: bold;
    font-size: small;
    color: black;
    /* height: 65%; */
    width: 90%;
    margin: auto;
    text-shadow: rgb(255, 255, 255) 1px 0px 0px,
        rgb(255, 255, 255) 0.540302px 0.841471px 0px,
        rgb(255, 255, 255) -0.416147px 0.909297px 0px,
        rgb(255, 255, 255) -0.989992px 0.14112px 0px,
        rgb(255, 255, 255) -0.653644px -0.756802px 0px,
        rgb(255, 255, 255) 0.283662px -0.958924px 0px,
        rgb(255, 255, 255) 0.96017px -0.279415px 0px;
    background-color: white;
    border-radius: 15px 15px 0 0;
    border-top: 2px solid red;
    border-left: 2px solid red;
    border-right: 2px solid red;
}

.Main_searchBar__CBH\\+h {
    border: 2px solid #1d1d1d;
    background: linear-gradient(
        0deg,
        rgba(29, 29, 29, 0.9304096638655462) 31%,
        rgba(191, 26, 26, 0.8435749299719888) 99%
    );
    font-weight: bold;
    color: #f2f2f2;
}

.Main_rt__WIiuZ {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 70px;
    height: 25px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.Main_rta__mo6wY {
    margin-top: 1px;
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
        "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
        monospace;
}
.Main_shown__ExlX3 {
    height: 30px;
}

input {
    width: 300px;
}

.Main_shelfedge__vX72n {
    text-align: center;
}

.Main_labelCount__5X1u\\+ {
    border: 1px solid red;
    color: black;
    background-color: #fff;
}

@media screen and (min-width: 300px) and (max-width: 1200px) {
    .Main_labelArea__-OBHt {
        width: 100%;
        margin-left: 6%;
    }
    input {
        width: 250px;
    }
    .Main_labelCount__5X1u\\+ {
        width: 90%;
        margin-left: 10%;
    }
    .Main_searchBar__CBH\\+h {
        width: 90%;
        margin-left: 10%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/StoreZone/RT_Labels/styles/Main.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI;oBACgB;IAChB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ;;;;;;oDAMgD;IAChD,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ;;;;;;oDAMgD;IAChD,uBAAuB;IACvB,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB;;;;KAIC;IACD,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yDAAuD;IACvD,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT;;oCAEgC;IAChC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI;iBACa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ","sourcesContent":["body {\n    background-color: #f2f0eb;\n    color: white;\n}\n\n.label {\n    /* width: 188px;\n    height: 143px; */\n    float: left;\n    /* background-size: 200px 148px; */\n    cursor: pointer;\n    padding-left: 2%;\n    padding-right: 1%;\n    padding-top: 1%;\n    padding-bottom: 1%;\n    gap: 5px;\n}\n\n.labelArea {\n    margin: auto;\n    width: 756px;\n    display: block;\n    overflow: auto;\n    height: 100%;\n    background-color: white;\n    box-shadow: 0px 0px 36px 8px #000000;\n    justify-content: space-evenly;\n}\n\n.price {\n    font-weight: bold;\n    font-size: small;\n    color: black;\n    width: 90%;\n    margin: auto;\n    text-shadow: rgb(255, 255, 255) 1px 0px 0px,\n        rgb(255, 255, 255) 0.540302px 0.841471px 0px,\n        rgb(255, 255, 255) -0.416147px 0.909297px 0px,\n        rgb(255, 255, 255) -0.989992px 0.14112px 0px,\n        rgb(255, 255, 255) -0.653644px -0.756802px 0px,\n        rgb(255, 255, 255) 0.283662px -0.958924px 0px,\n        rgb(255, 255, 255) 0.96017px -0.279415px 0px;\n    background-color: white;\n    border-radius: 0 0 15px 15px;\n    border-bottom: 2px solid red;\n    border-top: 1px solid red;\n    border-left: 2px solid red;\n    border-right: 2px solid red;\n}\n\n.name {\n    font-weight: bold;\n    font-size: small;\n    color: black;\n    /* height: 65%; */\n    width: 90%;\n    margin: auto;\n    text-shadow: rgb(255, 255, 255) 1px 0px 0px,\n        rgb(255, 255, 255) 0.540302px 0.841471px 0px,\n        rgb(255, 255, 255) -0.416147px 0.909297px 0px,\n        rgb(255, 255, 255) -0.989992px 0.14112px 0px,\n        rgb(255, 255, 255) -0.653644px -0.756802px 0px,\n        rgb(255, 255, 255) 0.283662px -0.958924px 0px,\n        rgb(255, 255, 255) 0.96017px -0.279415px 0px;\n    background-color: white;\n    border-radius: 15px 15px 0 0;\n    border-top: 2px solid red;\n    border-left: 2px solid red;\n    border-right: 2px solid red;\n}\n\n.searchBar {\n    border: 2px solid #1d1d1d;\n    background: linear-gradient(\n        0deg,\n        rgba(29, 29, 29, 0.9304096638655462) 31%,\n        rgba(191, 26, 26, 0.8435749299719888) 99%\n    );\n    font-weight: bold;\n    color: #f2f2f2;\n}\n\n.rt {\n    background-image: url(\"../../../../images/rt-logo.png\");\n    width: 70px;\n    height: 25px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.rta {\n    margin-top: 1px;\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n        \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n        \"Helvetica Neue\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n        monospace;\n}\n.shown {\n    height: 30px;\n}\n\ninput {\n    width: 300px;\n}\n\n.shelfedge {\n    text-align: center;\n}\n\n.labelCount {\n    border: 1px solid red;\n    color: black;\n    background-color: #fff;\n}\n\n@media screen and (min-width: 300px) and (max-width: 1200px) {\n    .labelArea {\n        width: 100%;\n        margin-left: 6%;\n    }\n    input {\n        width: 250px;\n    }\n    .labelCount {\n        width: 90%;\n        margin-left: 10%;\n    }\n    .searchBar {\n        width: 90%;\n        margin-left: 10%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `Main_label__APk67`,
	"labelArea": `Main_labelArea__-OBHt`,
	"price": `Main_price__0KAuv`,
	"name": `Main_name__CGgcW`,
	"searchBar": `Main_searchBar__CBH+h`,
	"rt": `Main_rt__WIiuZ`,
	"rta": `Main_rta__mo6wY`,
	"shown": `Main_shown__ExlX3`,
	"shelfedge": `Main_shelfedge__vX72n`,
	"labelCount": `Main_labelCount__5X1u+`
};
export default ___CSS_LOADER_EXPORT___;
